// extracted by mini-css-extract-plugin
module.exports = {"content":"FiltroSlider_content__JhLbW","bottom":"FiltroSlider_bottom__Ua5_G","rotation":"FiltroSlider_rotation__ZVWWv"};